type ChartDateValue = Date | number | string;

export type SinglePeriodRenderPoint = Record<string, unknown> & {
  startOn?: ChartDateValue;
  endOn?: ChartDateValue;
};

const parseChartDate = (value: ChartDateValue | undefined): Date | null => {
  if (value === undefined) {
    return null;
  }

  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
};

const addTimestep = (date: Date, timestep: string): Date => {
  const next = new Date(date);

  switch (timestep) {
    case 'DAY':
      next.setUTCDate(next.getUTCDate() + 1);
      break;
    case 'WEEK':
      next.setUTCDate(next.getUTCDate() + 7);
      break;
    case 'YEAR':
      next.setUTCFullYear(next.getUTCFullYear() + 1);
      break;
    default:
      next.setUTCMonth(next.getUTCMonth() + 1);
      break;
  }

  return next;
};

export const getSinglePeriodRenderData = (
  chartData: SinglePeriodRenderPoint[],
  shouldExpandSinglePeriod: boolean,
  timestep: string,
): SinglePeriodRenderPoint[] => {
  if (!shouldExpandSinglePeriod || chartData.length !== 1) {
    return chartData;
  }

  const point = chartData[0];
  const startDate = parseChartDate(point?.startOn);

  if (!point || !startDate) {
    return chartData;
  }

  const endDate = parseChartDate(point.endOn);
  const renderEndDate = endDate && endDate.getTime() > startDate.getTime() ? endDate : addTimestep(startDate, timestep);

  return [
    {
      ...point,
      startOn: startDate,
    },
    {
      ...point,
      startOn: renderEndDate,
    },
  ];
};
